import __vue_component__ from '../Popper/Popper.vue.js';

//
var script = {
  components: {
    Popper: __vue_component__
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    targetElement: {
      type: HTMLElement,
      default: undefined
    },
    placement: {
      type: String,
      default: 'bottom-end'
    },
    flipBehavior: {
      type: [String, Array],
      default: 'flip'
    },
    offset: {
      type: String,
      default: '0,5'
    },
    transitionDelay: {
      type: Number,
      default: 0
    },
    boundariesElement: {
      type: [String, HTMLElement, Function],
      default: 'viewport'
    },
    positionFixed: {
      type: Boolean,
      default: false
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/common/Popup.vue_rollup-plugin-vue=script.js